<template>
        <div style="margin:0 5px;">
                <div  style="margin-top:35px;margin-bottom:16px;">
                        <span class="title">耗材明细</span>
                </div>
                <el-table
                        :data="consumablesList"
                        border
                        :stripe="true"
                        style="width: 100%">
                        <el-table-column
                                type="index"
                                label="序号"
                                align='center'
                                width="50"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="consumableName"
                                label="耗材名称"
                                min-width="150"
                                align='center'
                        >
                        <template slot-scope="scope" >
                        <div style="display:flex">
                                <el-input v-model="scope.row.consumableName" disabled></el-input>
                                <el-button type="primary" size="small" @click="addConsumableObj(scope.$index)" v-if="isEdit">选择</el-button> 
                        </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                                prop="specification"
                                label="规格"
                                align='center'
                        >
                        <template slot-scope="scope" >
                        <el-input v-model="scope.row.specification" disabled></el-input>
                        </template>
                        </el-table-column>
                        <el-table-column
                                prop="vender"
                                align='center'
                                label="厂家">
                        <template slot-scope="scope" >
                        <el-input v-model="scope.row.vender" disabled></el-input>
                        </template>
                        </el-table-column>
                        <el-table-column
                                        prop="consumePrice"
                                        align='center'
                                        min-width="100"
                                        label="单价">
                                        <template slot-scope="scope" >
                                                <moneyInput v-model="scope.row.consumePrice"  :disabled="!isEdit" template="append" style="width: 100%"  /> 
                                        </template>
                                        </el-table-column>
                                        
                                        <el-table-column
                                        prop="consumeNum"
                                        align='center'
                                        label="数量">
                                        <template slot-scope="scope" >
                                                <el-input v-model="scope.row.consumeNum" v-input-filter:number  :disabled="!isEdit" maxlength="10" ></el-input>
                                        </template>
                                        </el-table-column>
                        
                        <el-table-column
                                prop="address"
                                align='center'
                                label="小计金额">
                        <template slot-scope="scope" >
                        <div class="money"><span>{{tool.money_format_allowvoid(scope.row.consumeNum*scope.row.consumePrice)  }}</span></div>
                        </template>
                        </el-table-column>
                        <el-table-column
                                v-if="isEdit"
                                prop="address"
                                align='center'
                                label="操作">
                        <template slot-scope="scope" >
                                <el-button type="primary"  size="small" @click="removeConsumable(scope.$index)" >删除</el-button>
                                </template>
                        </el-table-column>
                </el-table>
                <div v-if="isEdit">
                        <el-button type="primary" size="samll" style="width:100%;"  @click="addConsumable">+</el-button>
                </div>
                <el-form :value="submitForm" :inline="true" label-width="100px">
                <div  style="margin-top:35px;margin-bottom:34px;">
                        <span class="title">维修金额</span>
                </div>
                <el-row :gutter="20" :inline="true">
                        <el-col span="24">
                                <el-form-item label="维修金额:">
                                        <div style="width:280px">
                                                <moneyInput v-model="submitForm.amount" placeholder="请输入 维修金额" :disabled="!isEdit"    />
                                        </div>
                                </el-form-item>
                        </el-col>
                </el-row>
                <div  style="margin-top:35px;margin-bottom:34px;">
                        <span class="title">服务工时</span>
                </div>
                <el-row :gutter="20" :inline="true">
                        <el-col span="24">
                                <el-form-item label="服务工时:">
                                        <div style="width:300px">
                                                <a-time :time="submitForm.serviceHour" :disabled="!isEdit" @update="serviceTime"></a-time>

                                        </div>
                                </el-form-item>
                        </el-col>
                </el-row>
                </el-form>
                <div  style="margin-top:35px;margin-bottom:34px;">
                        <span class="title">设备信息</span>
                        <el-button size="small" v-show="isEdit" type="primary" @click="openChoiseDevice">关联设备</el-button>
                        <el-button size="small" v-show="isEdit" type="primary" @click="clear('device')">清 空</el-button>
                </div>
                <div>
                        <avue-form
                                :option="deviceOption"
                                v-model="deviceForm"
                                ref="deviceForm"
                        >

                        </avue-form>
                </div>
                <div  style="margin-top:35px;margin-bottom:34px;">
                        <span class="title">合同信息</span>
                        
                        <el-button size="small" v-show="isEdit" type="primary" @click="openChoiceContract">关联合同</el-button>
                        <el-button size="small" v-show="isEdit" type="primary" @click="clear('contract')">清 空</el-button>
                        <wq-choiceContract :projectId="form.projectId" ref="choiceContract" @getConstract="getContract"></wq-choiceContract>
                </div>
                <div>
                        <avue-form
                                :option="contractOption"
                                v-model="contractForm"
                                ref="contractForm"
                        >
                        <template slot="name">
                                <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="contractForm.name"
                                        placement="top"
                                >
                                       <el-input :value="contractForm.name" disabled></el-input>
                                </el-tooltip>
                        </template>
                        <template slot="code">
                                <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="contractForm.code"
                                        placement="top"
                                >
                                       <el-input :value="contractForm.code" disabled></el-input>
                                </el-tooltip>
                        </template>
                        <template slot="partnerName">
                                <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="contractForm.partnerName"
                                        placement="top"
                                >
                                       <el-input :value="contractForm.partnerName" disabled></el-input>
                                </el-tooltip>
                        </template>
                        </avue-form>
                </div>
                <div  style="margin-top:35px;margin-bottom:16px;">
                        <span class="title">评价信息</span>
                        
                </div>
                <div style="margin-left:50px;width:250px;">
                        <div v-for="item in evaluateDetailList" :key="item.id" >
                                <!-- {{item}} -->
                                <div style="display:inline-block;width:5rem;float:left;"> {{getEvaluateType(item.target)}}:</div>
                                <div style="display:inline-block;float:left;height: 2rem;box-sizing: border-box;padding: .4rem 0;">
                                    <el-rate
                                        v-model="item.level"
                                        disabled
                                        text-color="#ff9900"
                                        score-template="{value}">
                                        </el-rate>
                                </div>
                                <div style="display:inline-block;float:left;color:#f7ba2a">{{tag(item.level)}}</div>
                        </div>
                </div>
                <el-dialog
                        title="选择设备"
                        :visible.sync="choiceDeviceDialogFlag"
                        append-to-body="true"
                        width="80%"
                        :before-close="handleClose">
                        <choiceDevice @cancelOperate='cancelOperate' :projectId="this.form.projectId" @choiceData="getDevice"></choiceDevice>
                </el-dialog>
                <el-dialog
                        title="选择耗材"
                        :visible.sync="choiceConsumableFlag"
                        append-to-body="true"
                        :before-close="handleClose">
                <choiceConsumable @cancleOperate="consumableCancleOperate" :projectId='this.form.projectId' @close='dialogClose'  @choiceData="getConsumable"></choiceConsumable>
                </el-dialog>
        </div>

</template>
<script>
import choiceConsumable from '@/components/consumable/choiceConsumable';
import choiceDevice from '@/components/device/deviceChoice';
import VUpload from '@/views/components/v-upload';
import choiceContract from '@/components/choiceContract/choiceDeviceContract';
import ATime from '@/components/aTime/index';
import moneyInput from '@/components/money-input';
import aTime from "./aTime.vue";
import { repairUpdate } from "@/api/crmedical/order/order-list/order-list"; 
export default {
        components: { VUpload,choiceContract,choiceDevice,choiceConsumable,ATime,moneyInput,aTime},
        props:{
                evaluateDetailList:{
                        type:Array,
                        default:()=>{
                                return [];
                        }
                },
                evaluateTypeList:{
                        type:Array,
                        default:()=>{
                                return [];
                        }
                },
                form:{
                        type:Object,
                        default:()=>{
                                return {};
                        }
                },
                isEdit:{
                        type:Boolean,
                        default:true,
                }
        },

        data(){
                return{
                        operatConsumableIndex:undefined,
                        deviceForm:{},
                        contractForm:{},
                        submitForm:{},
                        choiceConsumableFlag:false,
                        choiceDeviceDialogFlag:false,
                        consumablesList:[{
                                consumableId: '',
                                consumableName:'',
                                specification:'',
                                vender: '',
                                consumeNum: '',
                                consumePrice: '',
                        
                        },],
                        consumable:{
                                consumableId: '',
                                consumableName:'',
                                specification:'',
                                vender: '',
                                consumeNum: '',
                                consumePrice: '',
                        
                        },
                        deviceOption:{
                                labelPosition: 'right',
                                labelSuffix: '：',
                                labelWidth: 100,
                                gutter: 0,
                                menuBtn: false,
                                submitBtn: true,
                                submitText: '提交',
                                emptyBtn: true,
                                emptyText: '清空',
                                menuPosition: 'center',
                                disabled: true,
                                column: [
                                        {
                                                type: 'input',
                                                label: '设备名称',
                                                span: 8,
                                                display: true,
                                                prop: 'name'
                                        },
                                        {
                                                type: 'input',
                                                label: '设备编号',
                                                span: 8,
                                                display: true,
                                                prop: 'code'
                                        },
                                        {
                                                type: 'input',
                                                label: '所属部门',
                                                span: 8,
                                                display: true,
                                                prop: 'deptName'
                                        },
                                        {
                                                type: 'input',
                                                label: '存放位置',
                                                span: 8,
                                                display: true,
                                                prop: 'areaName'
                                        },
                                        {
                                                type: 'input',
                                                label: '资产状态',
                                                span: 8,
                                                display: true,
                                                prop: 'assetStatus'
                                        },
                                        {
                                                type: 'textarea',
                                                label: '备注',
                                                span: 24,
                                                display: true,
                                                prop: 'description'
                                        }
                                ],
                                
                        },
                        contractOption:{
                                labelPosition: 'right',
                                labelSuffix: '：',
                                labelWidth: 120,
                                gutter: 0,
                                menuBtn: false,
                                submitBtn: true,
                                submitText: '提交',
                                emptyBtn: true,
                                emptyText: '清空',
                                menuPosition: 'center',
                                disabled: true,
                                column: [
                                                {
                                                        type: 'input',
                                                        label: '合同名称',
                                                        span: 8,
                                                        formslot:true,
                                                        display: true,
                                                        prop: 'name',

                                                },
                                                {
                                                        type: 'input',
                                                        label: '合同编号',
                                                        span: 8,
                                                        formslot:true,
                                                        display: true,
                                                        prop: 'code'
                                                },
                                                {
                                                        type: 'input',
                                                        label: '合同对象',
                                                        span: 8,
                                                        display: true,
                                                        formslot:true,
                                                        prop: 'partnerName'
                                                }
                                        ],
                                       
                        }
                }
        },
        watch:{
                form(val){
                        setTimeout(()=>{


                        
                        if(val.businessData){
                                let businessData = val.businessData
                                this.submitForm.deviceId = businessData.deviceId || "";
                                this.deviceForm.name = businessData.deviceName || "";
                                this.deviceForm.code = businessData.code || "";
                                this.deviceForm.deptName = businessData.deptName || "";
                                this.deviceForm.areaName = businessData.areaName || "";
                                this.deviceForm.assetStatus = businessData.assetStatusDesc || "";
                                this.deviceForm.description = businessData.deviceDescription || "";


                                this.submitForm.contractId = businessData.contractId;
                                this.contractForm.code = businessData.contractCode;
                                this.contractForm.name = businessData.contractName;
                                this.contractForm.partnerName = businessData.partnerName;

                                this.submitForm.amount = businessData.amount;

                                this.submitForm.serviceHour = businessData.serviceHour;
                                this.consumablesList = businessData.consumables || [];

                        }else{
                                this.consumablesList = [{
                                        consumableId: '',
                                        consumableName:'',
                                        specification:'',
                                        vender: '',
                                        consumeNum: '',
                                        consumePrice: '',
                                
                                },]
                        }
                        this.$forceUpdate();
                })
                }
             
        },
        methods:{
                // 清空
                clear(type){
                        if(type=='device'){
                                this.submitForm.deviceId = "";
                                this.deviceForm = {};
                                console.log(this.$refs.deviceForm)
                                this.$refs.deviceForm.resetForm()
                        }else{
                                this.submitForm.contractId = "";
                                this.contractForm = {};
                                this.$refs.contractForm.resetForm()
                        }
                },
                // 提交
                repairUpdate(){
                        this.submitForm.orderId = this.form.id;
                        
                        try{
                                if(this.consumablesList[0].consumableId){
                                        this.submitForm.deviceConsumables = this.consumablesList;
                                }else{
                                        this.submitForm.deviceConsumables = [];
                                }
                        }catch{
                                this.submitForm.deviceConsumables = [];
                        }
                        
                        repairUpdate(this.submitForm).then(res=>{
                                this.$message({
                                        message: '操作成功!',
                                        type: 'success'
                                });
                                this.$emit("handleClose", 'edit');
                        })
                },
                // 打开关联合同弹窗
                openChoiceContract(){
                        console.log(this.form)
                        this.$refs.choiceContract.openDialog();
                },
                // 获取时间组件数据
                serviceTime(date){
                        
                        //服务完成时间
                        this.submitForm.serviceHour =Number(date.hour)*60 + Number(date.minutes);
                },
                // 打开设备选择弹窗
                openChoiseDevice(){
                        this.choiceDeviceDialogFlag = true;
                },
                // 获取设备组件内容
                getDevice(val){
                        console.log(val)
                        this.submitForm.deviceId = val.id;
                        this.deviceForm.assetStatus = val.$assetStatus;
                        this.deviceForm.name = val.name;
                        this.deviceForm.code = val.code;
                        this.deviceForm.deptName = val.deptName;
                        this.deviceForm.areaName = val.areaName;
                        this.deviceForm.description = val.description;
                        this.choiceDeviceDialogFlag = false;
                },
                // 获取合同
                getContract(val){
                        console.log(val)
                        this.submitForm.contractId = val.id
                        this.contractForm.name = val.name;
                        this.contractForm.code = val.code;
                        this.contractForm.partnerName = val.partnerName;
                },
                // 打开耗材选择弹窗
                choiceConstract(){
                        this.choiceContractDialogFlag = true
                },
                
                consumableCancleOperate(){
                        this.choiceConsumableFlag=false
                },
                //添加耗材弹窗
                addConsumableObj(index){
                        this.operatConsumableIndex = index
                        this.choiceConsumableFlag = true
                },
                // 添加耗材
                getConsumable(val){
                        console.log(val)
                        let flag = false
                        this.consumablesList.forEach(element => {
                        if(element.consumableId ==val.id){
                                console.log('是重复的')
                                this.$message({
                                message: '该耗材已经存在！',
                                type: 'warning'
                                });
                                flag = true
                        }
                        });
                        if(!flag){
                        this.consumablesList[this.operatConsumableIndex].specification = val.specification
                                this.consumablesList[this.operatConsumableIndex].consumableId = val.id
                                this.consumablesList[this.operatConsumableIndex].consumePrice = val.price
                                this.consumablesList[this.operatConsumableIndex].consumeNum =1
                                this.consumablesList[this.operatConsumableIndex].vender = val.vender
                                this.consumablesList[this.operatConsumableIndex].consumableName = val.name
                                this.operatConsumableIndex =undefined
                        }
                        this.choiceConsumableFlag = false
                },
                addConsumable(){
                        this.consumable.index = ++this.consumable.index
                        this.consumablesList.push(Object.assign({},this.consumable))
                        console.log(this.consumablesList)
                },
                 //删除耗材
                removeConsumable(index){
                        let tagIndex = index;
 
                        this.consumablesList.splice(tagIndex, 1);
                },
                // 根据评价显示评价等级
                tag(level){
                        let tag = '';
                        if(level==2){
                                tag="差";
                        }else if(level==3){
                                tag="一般";
                        }else if(level==4){
                                tag="好";
                        }else if(level==5){
                                tag="非常好";
                        }else if(level==1){
                                tag="很差";
                        }else if(level==0){
                                tag="";
                        }
                        return tag;
                },
                getEvaluateType(type){
                        let name = '';
                        this.evaluateTypeList.forEach((ele,index)=>{
                                if(ele.dictKey === type){
                                name = ele.dictValue;
                                }
                        });
                        return name;
                },
        }
}
</script>
<style lang="scss" scoped>
.title{
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 19px;
        color: #606266;
        font-size: 14px;
        margin-right: 34px;
}
.totalScore{
        position: relative;
        top: -47px;
        height: 48px;
        line-height: 48px;
        text-align: right;
        font-size: 14px;
        border: 1px solid #eee;
}
</style>>